import client from './client';

const salesActivityUrl = '/api/v1/salesActivity';

export const getActivityList = (usrUuid) => {
  return client.get(`${salesActivityUrl}/list`, {
    params: { usrUuid }
  });
};

export const getActivityDetail = (activityId) => {
  return client.get(`${salesActivityUrl}/${activityId}`);
};

export const saveSalesActivity = (finalData) => {
  return client.post(`${salesActivityUrl}/save`, finalData);
};

export const deleteSalesActivity = (params) => {
  return client.post(`${salesActivityUrl}/delete`, params);
};
